/**
 * @generated SignedSource<<45cfa2ee5aad439b71c2d6cf0fe03329>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type TodoCategoryAdminListQuery$variables = Record<PropertyKey, never>;
export type TodoCategoryAdminListQuery$data = {
  readonly store: {
    readonly id: string;
    readonly todoCategories: ReadonlyArray<{
      readonly icon: TodoCategoryIcon | null;
      readonly id: string;
      readonly title: string;
    }>;
  };
};
export type TodoCategoryAdminListQuery = {
  response: TodoCategoryAdminListQuery$data;
  variables: TodoCategoryAdminListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Store",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "TodoCategory",
        "kind": "LinkedField",
        "name": "todoCategories",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icon",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryAdminListQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TodoCategoryAdminListQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b3c97dd9b9e45662a1f72faa7e1b8666",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryAdminListQuery",
    "operationKind": "query",
    "text": "query TodoCategoryAdminListQuery {\n  store {\n    id\n    todoCategories {\n      id\n      title\n      icon\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44091ffc469d2db3c4fcfbfdf9352d80";

export default node;
